import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { OpenInNew as LinkIcon } from "@mui/icons-material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

interface UsedByProduct {
  readonly productId: string;
  readonly productName: string;
}

interface UsedByProductsProps {
  readonly open: boolean;
  readonly products: readonly UsedByProduct[];
  readonly colSpan: number;
}

const UsedByProducts: FC<UsedByProductsProps> = ({ open, products, colSpan }) => {
  const navigate = useNavigate();

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={colSpan}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box sx={{ margin: 1 }}>
            <Typography variant="h6" gutterBottom component="div">
              Wykorzystywana przez produkty
            </Typography>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell>Nazwa produktu</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map(({ productId, productName }) => (
                  <TableRow key={productId}>
                    <TableCell>{productName}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        aria-label="Idź do produktu"
                        onClick={() => navigate(`/admin/products/${productId}`)}
                      >
                        <LinkIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default UsedByProducts;
